import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {SessionActions} from "../../../shared/actions";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {UserService} from "../../../crm/user/user.service";
import {ApolloQueryObservable} from "apollo-angular";
import {IUser} from "../../../shared/redux-store/session/session.types";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {UserFormComponent} from "../../../crm/components/user-form/user-form.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MessageType} from "../../../shared/redux-store/session";

@Component({
  selector: 'vb-user-list-view',
  templateUrl: './user-list-view.component.html',
  styleUrls: ['./user-list-view.component.css']
})
export class UserListViewComponent extends AbstractVisbosComponent implements OnInit {

  private users$: ApolloQueryObservable<any>;
  public users: IUser[];

  currentUserControl: FormGroup;

  actions = [
    {
      icon: 'fa-plus',
      label: 'Neuer Benutzer',
      action: () => this.showAddUserModal.apply(this),
      helpText: 'Einen neuen Benutzer anlegen'
    }
  ];

  @ViewChild('userModal')
  userModal: GenericModalComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private userService: UserService, private fb: FormBuilder) {
    super(sessionActions, cd);
  }

  ngOnInit() {

    super.ngOnInit();

    this.users$ = this.userService.getUsers();
    this.addComponentData(this.users$);
    this.addSubscription(this.users$.subscribe(res => {
      this.users = res.data.fetchUsers;
    }));

  }

  public showAddUserModal() {
    this.currentUserControl = UserFormComponent.initControl(this.fb);
    this.userModal.show();
  }

  public saveUser() {
    this.userService.createUser(this.currentUserControl.value).toPromise()
      .then(res => {
        this.sessionActions.pushMessage("Benutzer erfolgreich angelegt!", MessageType.SUCCESS, "Benutzerverwaltung");
      })
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Anlegen des Benutzers!", "Benutzerverwaltung"));

  }

}



// WEBPACK FOOTER //
// ./src/app/admin/views/user-list-view/user-list-view.component.ts